<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p><span>This book is dedicated to GEORGES BERTHOIN, one of the truly wise ones, who has mentored me in the ways of statecraft and governance. It is to Georges that I owe the genesis of this book.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?9460205a